<template>
  <div>
    <smart-table ref="smartTable" :headers="headers()" :search-function="searchFunction" preference-key="Receipt">
      <!-- smart table slot results -->
      <template v-slot:results="{ item: item }">
        <!-- employee -->
        <td>
          {{ item.employee.name }}
        </td>

        <!-- description -->
        <td>
          <div class="ellipsis">{{ item.description }}</div>
        </td>

        <!-- createdAt -->
        <td style="min-width: 160px">
          {{ item.createdAt }}
        </td>

        <!-- companyCard -->
        <td>
          <v-chip small label :color="getColor(item.companyCard).bg">
            <span :style="[{ color: getColor(item.companyCard).text }]">{{ item.companyCard ? translations.yes : translations.no }}</span>
          </v-chip>
        </td>

        <!-- processed -->
        <td>
          <v-chip small label :color="getColor(item.processed).bg">
            <span :style="[{ color: getColor(item.processed).text }]">{{ item.processed ? translations.yes : translations.no }}</span>
          </v-chip>
        </td>

        <!-- actions -->
        <td width="100">
          <div class="d-flex justify-space-around">
            <receipt :key="item.description" :itemId="item.id" @updated="$refs.smartTable.getTableRows()" />
          </div>
        </td>
      </template>
    </smart-table>
  </div>
</template>

<script>
import { translations } from '@/utils/common'
import SmartTable from '@/components/SmartTable'
import Receipt from './Receipt'
import ReceiptsService from '@/service/receipts/ReceiptsService'

export default {
  name: 'Receipts',

  components: {
    SmartTable,
    Receipt
  },

  methods: {
    headers() {
      const headers = []

      headers.push({
        type: 'TEXT',
        name: 'employeeName',
        label: translations.employee,
        sort: 'employeeName'
      })

      headers.push({
        type: 'TEXT',
        name: 'description',
        label: translations.description
      })

      headers.push({
        type: 'DATE-RANGE',
        name: 'createdAt',
        label: translations.createdAt,
        sort: 'createdAt'
      })

      headers.push({
        type: 'SELECT',
        name: 'companyCard',
        label: translations.companyCard,
        selectItems: [
          { text: translations.yes, value: true },
          { text: translations.no, value: false }
        ]
      })

      headers.push({
        type: 'SELECT',
        name: 'processed',
        label: translations.processedReceipt,
        selectItems: [
          { text: translations.yes, value: true },
          { text: translations.no, value: false }
        ]
      })

      // actions
      headers.push({
        type: 'HEADER-ITEM-1'
      })

      return headers
    },

    getColor(status) {
      const colors = {
        green: {
          bg: '#FCFCFC',
          text: '#2A6A2D'
        },
        red: {
          bg: '#FCFCFC',
          text: '#0661FF'
        }
      }
      if (status) return colors.green
      return colors.red
    },

    setSortAndOrder(params) {
      const booleanParams = ['companyCard', 'processed']

      booleanParams.forEach(param => {
        if (params[param] && params[param].length === 1) {
          params[param] = params[param][0]
        } else if (params[param] && (params[param].length > 1 || params[param].length === 0)) {
          delete params[param]
        }
      })

      if (params?.createdAt && params.createdAt.length === 2) {
        params.dateFrom = params.createdAt[0]
        params.dateTo = params.createdAt[1]
      } else if (params?.createdAt && params.createdAt !== 2) {
        delete params.createdAt
      }

      return params
    },

    searchFunction(params) {
      params = this.setSortAndOrder(params)
      return ReceiptsService.search(params)
    }
  },

  computed: {
    translations: () => translations
  }
}
</script>

<style>
.ellipsis {
  max-width: 500px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
